import { createIcon } from './icon-utils';

export const SmallFilledDownArrowIcon = createIcon({
  path: 'M6 0.5L3 4L0 0.5L6 0.5Z',
  viewBox: '0 0 6 4',
});
